var OV;
var session = {};
var publisher = {};
var subscriber;
var videoPreview;
var videoLive;
var canvasPreview;
var ctxPreview;
var canvasLive;
var ctxLive;

var cropPreviewTop = 0;
var cropPreviewBottom = 0;
var cropPreviewLeft = 0;
var cropPreviewRight = 0;

var cropLiveTop = 0;
var cropLiveBottom = 0;
var cropLiveLeft = 0;
var cropLiveRight = 0;

//var canvasLive;
var canvasAltura = 0;
var canvasLargura = 0;
import { OpenVidu } from "openvidu-browser";

//OV = new OpenVidu();

export const apiOpenVidu = {
  getSubscriber() {
    return subscriber;
  },
  getPublisher() {
    return publisher;
  },
  entrarSessaoB(evento, canal = "padrao") {
    OV = new OpenVidu();
    OV.enableProdMode();
    session[canal] = OV.initSession();

    session[canal].on("streamCreated", function(event) {
      subscriber = session[canal].subscribe(event.stream, "subscriber");
      //subscriber.subscribeToAudio(true);

      subscriber.on("videoElementCreated", (event) => {
        event.element["controls"] = true;
        //appendUserData(event.element, subscriber.stream.connection);
      });
    });

    var data = {};

    if (evento.linkFonte !== "") {
      if (evento.nome !== "" && evento.nome.indexOf("#") > -1) {
        var arrNome = evento.nome.split("#");
        data.clientData = "Client_" + arrNome[1];
      }
    }

    session[canal]
      .connect(evento.ovToken, data)
      .then(() => {})
      .catch((error) => {
        console.log("There was an error connecting to the session:", error.code, error.message);
      });

    window.onbeforeunload = function() {
      if (session[canal]) session[canal].disconnect();
    };
  },
  entrarSessaoA(token, dispositivoVideo, dispositivoAudio, canal = "1") {
    OV = new OpenVidu();
    OV.enableProdMode();
    session[canal] = OV.initSession();

    if (canvasLive) {
      dispositivoVideo = canvasLive.captureStream().getVideoTracks()[0];
    }

    var publishConfig = {
      audioSource: dispositivoAudio == "false" ? false : dispositivoAudio,
      publishAudio: dispositivoAudio == "false" ? false : false,
      publishVideo: true,
      videoSource: dispositivoVideo,
      //videoSource: undefined,
      frameRate: 25,
      resolution: "1280x720"
    };

    session[canal]
      .connect(token)
      .then(() => {
        publisher[canal] = OV.initPublisher("publisher", publishConfig);

        session[canal].publish(publisher[canal]);
      })
      .catch((error) => {
        console.log("There was an error connecting to the session:", error.code, error.message);
      });
  },
  async carregarDevices() {
    OV = new OpenVidu();
    return await OV.getDevices();
  },
  async definirCompartilhamento(dispositivoVideo) {
    // document.getElementById("videoPreview").innerHTML = "";

    if (videoPreview) {
      videoPreview.setAttribute("preview", false);
      //videoPreview.parentNode.removeChild(videoPreview);
    }

    /*if (canvasPreview) {
      canvasPreview.parentNode.removeChild(canvasPreview);
    }*/

    OV.getUserMedia({
      audioSource: false,
      videoSource: dispositivoVideo
    })
      .then((mediaStream) => {
        var videoTrack = mediaStream.getVideoTracks()[0];
        //var audioTrack = mediaStream.getAudioTracks()[0];

        videoPreview = document.createElement("video");
        //video.id = "videoPreviewObject";
        videoPreview.srcObject = new MediaStream([videoTrack]);
        // videoPreview.style.display = "none";
        videoPreview.setAttribute("preview", true);
        videoPreview.setAttribute("live", false);
        document.getElementById("containerVideos").appendChild(videoPreview);

        //canvasOriginal = document.createElement("canvas");

        if (!canvasPreview) {
          canvasPreview = document.createElement("canvas");
          canvasPreview.id = "canvasPreview";
          canvasPreview.style.maxWidth = "100%";
          canvasPreview.style.maxHeight = "300px";
          document.getElementById("containerPreview").appendChild(canvasPreview);
          ctxPreview = canvasPreview.getContext("2d");
        }

        if (!canvasLive) {
          canvasLive = document.createElement("canvas");
          canvasLive.id = "canvasLive";
          canvasLive.style.maxWidth = "100%";
          canvasLive.style.maxHeight = "300px";
          document.getElementById("containerLive").appendChild(canvasLive);
          ctxLive = canvasLive.getContext("2d");
        }

        videoPreview.addEventListener("play", (event) => {
          var loop = () => {
            var thisVideo = event.target;
            var live = thisVideo.getAttribute("live") == "true";
            var preview = thisVideo.getAttribute("preview") == "true";
            //var live = true;
            //var preview = true;

            if (!live && !preview) {
              return;
            }

            if (!thisVideo.paused && !thisVideo.ended) {
              if (preview) {
                ctxPreview.drawImage(thisVideo, cropPreviewLeft * -1, cropPreviewTop * -1);
              }

              if (live) {
                ctxLive.drawImage(thisVideo, cropLiveLeft * -1, cropLiveTop * -1);
              }

              //ctxPreview.drawImage(thisVideo, 0, -100);
              setTimeout(loop, 1000 / 30); // drawing at 30fps
            }
          };
          loop();

          var loopMedida = () => {
            var thisVideo = event.target;
            var live = thisVideo.getAttribute("live") == "true";
            var preview = thisVideo.getAttribute("preview") == "true";

            if (!live && !preview) {
              thisVideo.parentNode.removeChild(thisVideo);
              return;
            }

            var previewLargura = thisVideo.videoWidth + cropPreviewLeft * -1 + cropPreviewRight * -1;
            var previewAltura = thisVideo.videoHeight + cropPreviewTop * -1 + cropPreviewBottom * -1;

            var liveLargura = thisVideo.videoWidth + cropLiveLeft * -1 + cropLiveRight * -1;
            var liveAltura = thisVideo.videoHeight + cropLiveTop * -1 + cropLiveBottom * -1;

            if (preview && (canvasLargura != previewLargura || canvasAltura != previewAltura)) {
              canvasLargura = previewLargura;
              canvasAltura = previewAltura;

              canvasPreview.width = previewLargura;
              canvasPreview.height = previewAltura;
            }

            if (live && (canvasLive.width != liveLargura || canvasLive.height != liveAltura)) {
              canvasLive.width = liveLargura;
              canvasLive.height = liveAltura;
            }

            setTimeout(loopMedida, 1000);
          };
          loopMedida();
        });
        videoPreview.play();
      })
      .catch((err) => {
        console.error(err);
      });
  },
  async livePreview() {
    cropLiveTop = cropPreviewTop;
    cropLiveBottom = cropPreviewBottom;
    cropLiveLeft = cropPreviewLeft;
    cropLiveRight = cropPreviewRight;

    if (videoLive) {
      videoLive.setAttribute("live", false);
    }

    videoPreview.setAttribute("live", true);

    videoLive = videoPreview;
  },
  fecharSessao(canal = "1") {
    session[canal].disconnect();
  },
  cropPreview(top, bottom, left, right) {
    cropPreviewTop = top;
    cropPreviewBottom = bottom;
    cropPreviewLeft = left;
    cropPreviewRight = right;
  },
  cropLive(top, bottom, left, right) {
    cropLiveTop = top;
    cropLiveBottom = bottom;
    cropLiveLeft = left;
    cropLiveRight = right;
  },
  getCanvasLive() {
    return canvasLive;
  }
};
